module.exports = __webpack_public_path__ + "media/old_images/image-promo-landing-03-c544b58e.jpg";